// extracted by mini-css-extract-plugin
module.exports = {"root":"TIIv1vPO"};